// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__Ifpd8","title":"InfoRow_title__1jqL3"};